import { createClient } from '@/lib/supabase/client';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/types/supabase';

export function ensureClient(): SupabaseClient<Database> {
  return createClient();
}

// Re-export the slugify function from lib/utils for backward compatibility
export { slugify } from '@/lib/utils';
